module.exports = __webpack_public_path__ + "static/media/smirking-face.c6a05a64.png";